import CronAdapter from './base';

export default class ProcessMonitor extends CronAdapter {
  modelNamePlural = 'processMonitors';
}
